import React from "react";
import { useLocation } from "react-router-dom";
import HelpContactSection from "./HelpContactSection";
import HelpFaqSection from "./HelpFaqSection";
import HelpGuideSection from "./HelpGuideSection";
import HelpHero from "./HelpHero";
import HelpTopicsSection from "./HelpTopicsSection";
import useHelpFaqAnchor from "./useHelpFaqAnchor";
import "./HelpPageShared.scss";
import "./helpPage.scss";

const HelpPage = () => {
  const location = useLocation();
  const { activeKey, setActiveKey } = useHelpFaqAnchor(location.hash);

  return (
    <main className="help-page">
      <HelpHero />
      <HelpTopicsSection />
      <HelpGuideSection />
      <HelpFaqSection activeKey={activeKey} onChange={setActiveKey} />
      <HelpContactSection />
    </main>
  );
};

export default HelpPage;
